import { styled } from 'styled-components';

import plusIcon from '~/assets/icons/plus.svg';

const StyledContainer = styled.div`
	position: absolute;
	height: 20px;
	right: 0;
	display: flex;
	align-items: center;
	gap: 10px;
	user-select: none;
`;

const StyledLabelContainer = styled.div`
	position: relative;
	display: flex;
	align-items: flex-end;
	font-family: 'GT Walsheim Pro';
	font-weight: bold;
	font-size: 16px;
	line-height: 18px;
	color: #fff;

	span {
		font-weight: normal;
		font-size: 12px;
		line-height: 14px;
		color: rgba(255, 255, 255, 0.5);
	}
`;

const StyledParkingSlotsButton = styled.img.attrs({ src: plusIcon })`
	width: 20px;
	height: 20px;
	padding: 5px;
	border-radius: 6px;
	background-color: rgba(31, 128, 52, 0.5);
	transition: background-color 0.25s ease;

	&:hover {
		background-color: rgba(31, 128, 52, 1);
		cursor: pointer;
	}
`;

export { StyledContainer, StyledLabelContainer, StyledParkingSlotsButton };
